import Vue from 'vue'
import DropdownMenu from 'v-dropdown-menu'
import 'v-dropdown-menu/dist/v-dropdown-menu.css'

Vue.use(DropdownMenu)